import { render } from "./CompanyTvaRegimeModal.vue?vue&type=template&id=041fa0cd&scoped=true"
import script from "./CompanyTvaRegimeModal.vue?vue&type=script&lang=js"
export * from "./CompanyTvaRegimeModal.vue?vue&type=script&lang=js"

import "./CompanyTvaRegimeModal.vue?vue&type=style&index=0&id=041fa0cd&lang=stylus&scoped=true"
import "./CompanyTvaRegimeModal.vue?vue&type=style&index=1&id=041fa0cd&lang=stylus"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-041fa0cd"]])

export default __exports__